import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getNarrativeSelector } from '../selectors'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { NarrativeConstants } from '../store/narrative.constants'
import { INarrativeState } from '../store/narrative.types'
import { setSaveNarrativeResponse } from '../store/narrative.actions'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* saveNarrativeText() {
  const narrative: INarrativeState = yield select(getNarrativeSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient, narrative } }
    try {
      const response: string = yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(setSaveNarrativeResponse(response))
    } catch (e) {
      yield put(throwPcrException(`setNarrativeText() error: ${e}`))
    }
  }
}
export function* saveNarrativeTextSaga() {
  yield takeLatest(
    [
      NarrativeConstants.SET_NARRATIVE_TEXT,
      NarrativeConstants.SET_NARRATIVE_TEXT_PNNV,
      NarrativeConstants.SAVE_NARRATIVE,
    ],
    performWithMutexHOG,
    saveNarrativeText
  )
}
